import { Box } from '@wix/design-system';
import React, { FunctionComponent, useContext } from 'react';

import { LoggedIn } from './LoggedIn';
import { NotLoggedIn } from './NotLoggedIn';
import { SearchBarModal } from './SearchBarModal';
import { Context } from '../../../context';
import { useIxWixelRelated } from '../../../hooks/useIsWixelRelated';
import { PageType } from '../../../types';
import { useStore } from '../../../zustand/stores';

export const HeaderRight: FunctionComponent = () => {
  const { user } = useStore((state) => state.userSlice);
  const { pageType } = useContext(Context);
  const shouldHideSearchBar = useIxWixelRelated() || pageType === PageType.SearchResults;

  return (
    <Box gap={2}>
      {!shouldHideSearchBar && <SearchBarModal />}
      {user === null ? <NotLoggedIn /> : <LoggedIn />}
    </Box>
  );
};
